import styled from 'styled-components';
import { Typ51, Typ35 } from 'dc/Typ';
import TxtField07 from 'dc/TxtField07';
import Btn020 from 'dc/Btn020';
import Btn021 from 'dc/Btn021';
import NpsRadioButtons from 'challenge/common/NpsRadioButtons';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: transparent;
  text-align: center;
  width: 100%;
`;

export const Question = styled(Typ51)`
  margin-bottom: 24px;
`;

export const NpsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 64px;
`;

export const SmallText = styled(Typ35)`
  line-height: 19px;
`;

export const NpsButtons = styled(NpsRadioButtons)`
  margin: 0 16px;
`;

type HiddenWrapperProps = {
  display?: boolean;
};

export const HiddenWrapper = styled.div<HiddenWrapperProps>`
  height: ${props => (props.display ? '262px' : '0')};
  opacity: ${props => (props.display ? '1' : '0')};
  width: 100%;
  transition:
    height 0.5s,
    opacity 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const TextArea = styled(TxtField07)`
  margin-bottom: 22px;
  height: 144px;
  width: 100%;
  > div {
    height: 100%;
  }
`;

export const ButtonsWrapper = styled.div`
  align-self: flex-end;
  margin-bottom: 40px;
`;

export const CancelButton = styled(Btn020)`
  height: 36px;
`;

export const SendButton = styled(Btn021)`
  height: 36px;
  margin-left: 40px;
`;
